import { StaticProps } from '../../context/StaticPropsContext';
import { createSchema } from '~/lib/useQueryParameter';
import { pageNumberParameter } from './pageNumberParameter';
import { pageSizeParameter } from './pageSizeParameter';
import { ApplicationExportSearchQuery } from '../../data/useApplicationExports';

export type Parameters = {
  pageNumber: number;
  pageSize: number;
};

export const schema = createSchema<StaticProps, ApplicationExportSearchQuery, Parameters>({
  pageNumber: pageNumberParameter,
  pageSize: pageSizeParameter,
});
